import ApiClient from '@/api/ApiClient';
import Payment from '@/api/models/Payment';
import Response from '@/api/models/Response';
import UseStoreHandler from '@/composables/handlers/UseStoreHandler';

class PaymentService {
    #prefixUrl = 'api/payment/';

    constructor() {
        this.api = new ApiClient(this.#prefixUrl);
    }

    /**
     * Gets Payment
     * @param {integer} paymentId
     * @return {Payment|Null}
     */
    async getPayment(paymentId = null) {
        const response = await this.api.executeRequest(`/reference/${paymentId}`, {}, this.api.methods.GET);
        return response.success() ? new Payment(response.getContent()) : null;
    }

    /**
     * Opens Mercado Pago receipt page
     * @param {String} paymentId 
     */
    async openMercadoPagoReceiptPage(paymentId = '') {
        window.open(`https://www.mercadopago.com.br/tools/receipt-view/${paymentId}`, '_blank');
    }

    /**
     * Generates a payment link (preference) and return generated link
     * @param {Array} courseUuids*
     * @returns {Response}
     */
    async generatePaymentLink(courseUuids = []) {
        if (!courseUuids || !Array.isArray(courseUuids) || !courseUuids.length) {
            return new Response({status: 404, resMessage: 'no items sent'});
        }
        return await this.api.executeRequest('', {items: courseUuids, currency: 1, type: 'uuid'}, this.api.methods.POST);
    }

    /**
     * Opens sent direction into another blank tab
     * @param {String} direction 
     */
    async openPaymentLink(direction = '') {
        window.open(direction, '_blank');
    }

    /**
     * Gets pending payments by desc order
     * @returns {array}
     */
    async getPendingPayments() {
        if (!UseStoreHandler.getAuthStore().isAuthenticated) {
            return [];
        }

        const response = await this.api.executeRequest('/pending_payment', {}, this.api.methods.GET);

        let paymentsList = [];

        if (response.success()) {
            for (let item of response.getContent()) {
                paymentsList.push(new Payment(item));
            }
        }

        return paymentsList;
    }

    /**
     * Gets payments by status.
     * Either: approved, expired and refused
     * @param {integer} status 
     * @returns {array}
     */
    async getPaymentsByStatus(status = 1) {
        const response = await this.api.executeRequest('/', {status: status}, this.api.methods.GET);

        let paymentsList = [];

        if (response.success()) {
            for (let payment of response.getContent()) {
                paymentsList.push(new Payment(payment));
            }
        }

        return paymentsList;
    }
}

export default new PaymentService();
